/*
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
*/
import { html, Polymer } from '@polymer/polymer/polymer-legacy.js';

const template = html`
        <oe-ajax id="paykey" on-response='publicKeyHandler'> </oe-ajax>
   `;

Polymer({
    is: 'key-management',
    _template: template,

    properties: {
        _publicKey: {
            type: Object,
            notify: true,
            readOnly: true
        },
        _symmetricKey: {
            type: String,
            notify: false,
            readOnly: true
        }
    },
    ready: function () {
        this.$.paykey.url = localStorage.baseurl + "/paykey";
        if (typeof sessionStorage.auth_token != "undefined" && typeof sessionStorage.state != "undefined") {
            var state = JSON.parse(sessionStorage.state);
            this._set_symmetricKey(state.key);
            sbEncrypt.setConfig({
                'key': this._symmetricKey
            });
            delete sessionStorage.state;
        } else if (forge) {
            this._set_symmetricKey(forge.random.getBytesSync(16));
            sbEncrypt.setConfig({
                'key': this._symmetricKey
            });
        } else {
            this.fire("Sorry for inconvenience, please reload application again!!!");
        }
        this.fetchPublicKey();
    },
    fetchPublicKey: function () {
        if (sessionStorage.getItem('auth_token')) {
            return;
        }
        if (this.$.paykey)
            this.$.paykey.generateRequest();
    },
    publicKeyHandler: function (event) {
        var self = this;
        this._set_publicKey(forge.pki.publicKeyFromPem(event.detail.response.publicKey));
        setTimeout(function () {
            self.fetchPublicKey();
        }, 300000);
        sessionStorage.payKeyCall = false;
    },
    /* Function for pay key call*/
    fetchNewPublicKey: function () {
        this.$.paykey.generateRequest();
    },
    setSymKeyInLocal: function () {
        if (typeof sessionStorage.auth_token === "undefined")
            return;
        var state = {};
        if (sessionStorage.state)
            state = JSON.parse(sessionStorage.state);
        state.key = this._symmetricKey;
        sessionStorage.state = JSON.stringify(state);
    },
    /** Function to add encrypted-encoded symetric key in sessionStorage */
    setSymKeyInSession: function () {
        if (typeof sessionStorage.auth_token === "undefined") {
            return;
        }
        sessionStorage.sessionState = btoa(this._publicKey.encrypt(this._symmetricKey));
    },
    //function created to get encrypted symkey to set in headers for prelogin payload encryption
    getEncryptedSymKey: function () {
        return btoa(this._publicKey.encrypt(this._symmetricKey));
    },
    setSymKey: function (body) {
        if (typeof body == "object") {
            body.symKey = this._publicKey.encrypt(this._symmetricKey);
            body.symKey = btoa(body.symKey);
            if (config.SpeedBoat && config.SpeedBoat.App && config.SpeedBoat.App.payloadEncryption)
                body.symmKey = this._symmetricKey;
            return body;
        }
        var bodyInt = JSON.parse(body);
        bodyInt.symKey = this._publicKey.encrypt(this._symmetricKey);
        bodyInt.symKey = btoa(bodyInt.symKey);
        if (config.SpeedBoat && config.SpeedBoat.App && config.SpeedBoat.App.payloadEncryption)
            bodyInt.symmKey = this._symmetricKey;
        return JSON.stringify(bodyInt);
    },
    verify: function (body) {
        var md = forge.md.sha256.create();
        md.update(body.id);
        if (this._publicKey.verify(md.digest().bytes(), forge.util.hexToBytes(body.signature))) {
            return true;
        }
        return false;
    }
});
window.addEventListener("beforeunload", function () {
    // store symKey in sessionStorage
    document.getElementById('keyManagement').setSymKeyInLocal();
});

